import { FIELD_TYPES } from "constants/template-field-type";
import SelectableTagsTagsFieldsConfig from "segments/desktop/core-components/selectable-tags-grid/fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Selectable tags layout",
    fields: SelectableTagsTagsFieldsConfig
};
